export const addCart = (count) => {
  return {
    type: 'ADD_CART',
    payload: count,
  };
};

export const addProduct = (product) => ({
  type: 'ADD_PRODUCT',
  payload: product,
});

export const removeProduct = (unqid) => ({
  type: 'REMOVE_PRODUCT',
  payload: unqid,
});

export const updateCartItemCount = (unqid, type) => ({
  type: 'UPDATE_PRODUCT_COUNT',
  payload: { unqid, type },
});

export const clearCart = () => ({
  type: 'CLEAR_CART'
});
